import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;
    .company-name {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      font-size: 22px;
    }
  }

  .links {
    display: block;
    text-align: center;
    width: 100%;
    .link {
      margin-bottom: 5px;
      a {
        text-decoration: none;
        color: #686868;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
`;

const Home = () => (
  <Container style={{ marginTop: "20%", width: "100%", height: "100%" }}>
    <div className="logo">
      <img style={{ height: 100 }} src="logo.svg" alt="logo" />
      <div className="company-name">
        <span className="sans-serif weight-400">Sharon</span>
        <span style={{ paddingLeft: 8 }} className="sans-serif weight-400">
          Wang
        </span>
        <span style={{ marginLeft: "-2px" }} className="sans-serif weight-400">
          Architect
        </span>
      </div>
    </div>
    <div className="links">
      <div className="link">
        <Link className="body" to="/about">
          About
        </Link>
      </div>
      <div className="link">
        <Link className="body" to="/projects">
          Gallery
        </Link>
      </div>
    </div>
  </Container>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js